import Listbox from 'primevue/listbox'
import MgDocs from './mg-docs.vue'

import {Rest} from 'utils'
import {API_ADMIN_MONGO} from 'consts/api'

const __default__ = {
  data() {
    return {
      rest: new Rest(),
      collections: undefined,
      selection: undefined,
      active: 'documents',
      tabs: [
        {value: 'documents', title: 'Documents'}, 
        {value: 'indexes', title: 'Indexes'}
      ]
    }
  },
  async mounted() {
    this.collections = await this.rest.get(`${API_ADMIN_MONGO}/collections`)
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'mongo',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get Rest() { return Rest }, get API_ADMIN_MONGO() { return API_ADMIN_MONGO }, get Listbox() { return Listbox }, MgDocs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})